/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { ReactElement } from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";

import { gray, black } from "../../../../helperFunctions/styledComponents";
import Toggle from "../../../reusable/toggle";

interface AutomaticApprovalToggleProps {
  approvedAutomatically: boolean;
  submitting: boolean;
  handleApproveAutomaticallyChange: (checked: boolean) => void;
}

const StyledToggleWrapper = styled.div`
  padding: 0 30px 15px 30px;
  border-bottom: 1px solid ${gray};
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const StyledToggleText = styled.label`
  margin-right: 15px;
  color: ${black};
`;

const AutomaticApprovalToggle = ({
  approvedAutomatically,
  handleApproveAutomaticallyChange,
  submitting,
}: AutomaticApprovalToggleProps): ReactElement => {
  return (
    <StyledToggleWrapper>
      <StyledToggleText htmlFor="autoApprove">
        {i18n.translate("awards.modal.auto_approve")}
      </StyledToggleText>
      <Toggle
        checked={approvedAutomatically}
        name="autoApprove"
        id="autoApprove"
        onChange={handleApproveAutomaticallyChange}
        disabled={submitting}
      />
    </StyledToggleWrapper>
  );
};

export default AutomaticApprovalToggle;
